import React, { useState, useEffect } from 'react'
import styles from '../style/freeTrial.module.css';
import trialHeroImg from '../assets/freeTrialHeroImg.webp';
import checkIcon from '../assets/checkCircleIcon.png';
import useMediaQuery from '../../../hooks/useMediaQuery';
import { CheckoutService } from '../../../services/CheckoutService';

const Hero = ({ trial }) => {
    const isAboveMediumScreens = useMediaQuery("(min-width: 500px)");

    const [priceId, setPriceId] = useState('');
    const [price, setPrice] = useState('');

    function showPrices(label, currecny, price) {
        setPrice(label);
    }

    useEffect(() => {
        const onInit = async () => {
            let data = await CheckoutService.getSinglePackage();
            let price = data.prices[0];
            setPriceId(price.id);
            showPrices(price.label, price.currency, price.amount);
        }
        onInit();
    }, [trial]);


    return (
        <section>
            <div className={styles.heroBgImage}>
                <div className='maxScreen'>
                    <div className={styles.mainCard}>
                        {!isAboveMediumScreens && <div className={styles.imageContainer}>
                            <img src={trialHeroImg} alt="" className={styles.img} />
                        </div>}
                        <div className={styles.textContainer}>
                            <h2 className={styles.title}>Get Complete Peace <br /> of Mind, <span style={{ color: '#000' }}>Risk-Free.</span></h2>
                            <div className={styles.price}>$0.00 <p className={styles.today}>7 Days</p></div>
                            <div className={styles.regPrice}>Then just {price} a month</div>
                            <div className={styles.featureContainer}>
                                <ul className={styles.featureList}>
                                    <li className={styles.listItem}>
                                        <img src={checkIcon} alt="checkIcon" width={15} height={15} /><p className={styles.feature}>Cancel anytime</p>
                                    </li>
                                    <li className={styles.listItem}>
                                        <img src={checkIcon} alt="checkIcon" width={15} height={15} /><p className={styles.feature}>Live Location Tracking</p>
                                    </li>
                                    <li className={styles.listItem}>
                                        <img src={checkIcon} alt="checkIcon" width={15} height={15} /><p className={styles.feature}>Automatic Place Alerts</p>
                                    </li>
                                    <li className={styles.listItem}>
                                        <img src={checkIcon} alt="checkIcon" width={15} height={15} /><p className={styles.feature}>Full Location History</p>
                                    </li>
                                </ul>
                            </div>
                            <div className={styles.buttonContainer}>
                                <button className={styles.startTrackingButton} onClick={() => CheckoutService.initStripeSession(priceId, trial)}>Start your free 7-day trial</button>
                                <p className={styles.reminder}>We'll email you a reminder before your trial ends</p>
                            </div>

                        </div>
                        {isAboveMediumScreens && <div className={styles.imageContainer}>
                            <img src={trialHeroImg} alt="" className={styles.img} />
                        </div>}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Hero